import { MessageList } from 'react-chat-elements';
import styled from 'styled-components';

const MessageListStyled = styled(MessageList)`
  div[class*=rce-avatar-container] {
    border-radius: 100%;
  }
  div[class*=rce-mbox-text] {
    white-space: pre-line;
  }
  div[class*=rce-smsg] {
    background-color: #f2f2f2;
    color: gray;
    font-size: 14px;
  }
  .rce-mbox {
    background-color: #cce6ff;
  }
  .rce-mbox-left-notch {
    fill: #cce6ff;
  }
  .rce-mbox-right {
    background-color: #ccffcc;
  }
  .rce-mbox-right-notch {
    fill: #ccffcc;
  }
  .rce-mbox-photo {
    background-color: #fff;
  }

  div[class*=date-msg] {
    div[class*=rce-smsg] {
      font-size: 12px;
      padding: 2px 3px;
    }
  }
`;

export default MessageListStyled;
